import { apiClient } from "@/shared/api/client";
import {
    GetHolidaysResponseDto,
    SaveHolidayRequest,
    HolidayDto
} from "@/features/policy/holidayManagement/types/holiday.types";

const BASE_PATH = '/api/v1/holiday';

export const holidayApi = {
    getHolidays: async (year?: string): Promise<GetHolidaysResponseDto> => {
        const response = await apiClient.get<GetHolidaysResponseDto>(BASE_PATH, {
            params: year ? { year } : undefined,
        });
        return response.data;
    },

    saveHoliday: async (request: SaveHolidayRequest): Promise<HolidayDto> => {
        const response = await apiClient.post<HolidayDto>(BASE_PATH, request);
        return response.data;
    },

    deleteHoliday: async (seqNo: number): Promise<void> => {
        await apiClient.delete<void>(`${BASE_PATH}/${seqNo}`);
    },

    syncKoreanHolidays: async (year: number, userId: string): Promise<{ year: number; savedCount: number }> => {
        const response = await apiClient.post<{ year: number; savedCount: number }>(
            `${BASE_PATH}/sync/${year}`,
            null,
            { params: { userId } }
        );
        return response.data;
    },
};
